import { useTranslation } from 'react-i18next';
import { VdsButton, VdsIcon } from '@volt/volt-extended-components-react';
import { ReactElement, useCallback, useState } from 'react';
import { refreshIconAnimated } from '@cas/components/icons/icons';
import type { TagDescription } from '@reduxjs/toolkit/query/react';

export interface RefreshButtonControllerProps<T> {
  tagsToClear: TagDescription<T>[];
  disabled?: boolean;
}

interface RefreshButtonProps {
  invalidateTagsCallback: () => void;
  disabled?: boolean;
}

export const RefreshButton = ({
  invalidateTagsCallback,
  disabled = false,
}: RefreshButtonProps): ReactElement => {
  const { t } = useTranslation();

  const [isRefreshing, setIsRefreshing] = useState<boolean>(false);

  const onRefresh = useCallback(() => {
    // Disable the button for 2s after being clicked.
    setIsRefreshing(true);
    setTimeout(() => {
      setIsRefreshing(false);
    }, 2000);

    // Invalidate the specified tags to trigger automatic refetching of any matching querys that are mounted.
    invalidateTagsCallback();
  }, [invalidateTagsCallback]);

  return (
    <VdsButton variant="secondary" onClick={onRefresh} disabled={disabled || isRefreshing}>
      {t('Refresh')}
      <VdsIcon slot="icon-left" svgIcon={isRefreshing ? refreshIconAnimated : 'refresh'} />
    </VdsButton>
  );
};

export default RefreshButton;
